<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <h5 class="title t-apply"></h5>

                    <div class="card-view">
                        <vuescroll>
                            <div class="card-list">
                                <div class="card-item" v-for="(item,key,index) in cards" :key="index">
                                    <div class="card-content" v-if="have_card(key)" :class="{'active' : card_idx == index}"
                                    @click="card_idx = index;now_card = item;">
                                        <div class="label">{{ item.theme }}</div>
                                        <div class="card-cnt">{{ card_cnt(key) }}</div>
                                    </div>

                                    <div class="card-default" v-else></div>
                                </div>
                            </div>
                        </vuescroll>
                    </div>

                    <div class="warn">确认与好友【{{ player_data.nickName }}】互赠许愿签~</div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" v-if="$store.state.login" @click="apply"></div>
                        <div class="u-btn login" v-else @click="$mslogin.login"></div>                                                                   
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    position: relative;
    width: 705px;
    height: 580px;
    background-image: url(~@/assets/images/modal/bg-modal-apply.png);   
}

.t-apply{
    width: 427px;
    height: 30px;
    margin: 0 auto 32px;
    background-image: url(~@/assets/images/modal/title-apply.png);      
}

.card-view{
    width: 580px;
    height: 290px;
    margin: 0 auto;
}

.card-list{
    display: flex;
    // width: 2000px;
    box-sizing: border-box;
    padding-top: 30px;

    .card-item{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        width: 94px;
        height: 230px;
        margin: 0 12px;
        z-index: 2;
        font-family: 'HYJinKaiJ';
        
        .card-content{
            position: relative;
            width: 94px;
            height: 231px;
            background-image: url(~@/assets/images/card-common.png);
            background-position: center bottom;
            background-repeat: no-repeat;

            &.active{
                height: 231px;
                background-image: url(~@/assets/images/card-active.png);                    
                
                &::after{
                    display: block;
                    content: '';
                    position: absolute;
                    left: 50%;
                    bottom: 46px;
                    transform: translate(-50%,0);
                    width: 72px;
                    height: 165px;
                    box-shadow: 0 0 20px 5px rgba(255,215,0,0.8);
                    animation: breath 4s linear infinite;
                }
            }

            .label{
                width: 32px;
                line-height: 32px;
                color: #ffe56c;
                font-size: 29px;
                position: absolute;
                top: 42%;
                left: 50%;
                transform: translate(-50%,-50%);                 
            }

            .card-cnt{
                position: absolute;
                top: 5px;
                right: 0;
                width: 30px;
                height: 30px;
                line-height: 30px;
                border-radius: 50%;
                background-color: #f64832;
                color: #ffeec3;
                font-size: 20px;
                text-align: center;
                z-index: 4;
            }
        }

        .card-default{
            width: 94px;
            height: 267px;
            background-image: url(~@/assets/images/card-default.png);
        }
    }
}

.warn{
    margin-top: 20px;
    font-size: 18px;
    text-align: center;
    color: #a09390;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}

.u-btn.ok{
    width: 224px;
    height: 65px;
    margin: 0 auto;
    background-image: url(~@/assets/images/modal/btn-exchange.png);    
}

.u-btn.login{
    width: 224px;
    height: 65px;
    margin: 0 auto;
    background-image: url(~@/assets/images/modal/btn-login.png);    
}

</style>

<script>
import cards from '@/components/data/card.js';
import { apiShareApply , apiShareInfo , apiCardInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码
            card_idx : -1,
            now_card : {}, 
            card_list : [],
            total : 0,
            cards, 
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.render();
        this.fetch_data();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        fetch_data() {
           apiCardInfo().then(res => {
               if(res.data){
                   this.card_list = res.data.cards;
                   this.total = res.data.cardNum;
               }
           }); 
        },        
        render() {
            var _this = this;
            apiShareInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', ''); 
                    this.destroyElement ();                    
                },
            );
        },
        have_card(cid) {
            return this.card_list.filter((ele)=>{
                if(ele.giftId == cid){
                    return true;
                }
            }).length ? true : false;
        },        
        card_cnt(cid) {
            let cnt = 0;
            this.card_list.forEach((ele)=>{
                if(ele.giftId == cid){
                    cnt = ele.num;
                }
            });
            return cnt;
        },                
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            if(!this.now_card.id){
                return this.$toast('请先选择要交换的许愿签');
            }

            this.apply_team();
        },
        apply_team (){
            apiShareApply({ code : this.code , giftId : this.now_card.id }).then(
                res => {
                    this.destroyElement();
                    this.$toast('分享成功~')
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                   
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '该用户累计加入次数已达上限' : rej.message;
                    this.$toast(rej.message);
                    //this.$msg_modal({type : 'error-apply' ,text : rej.message});
                    
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       
                },
            );
        },                
    },
}
</script>